import BaseDatePicker from './InputTypes/BaseDatePicker';
import { IBaseDatePickerProps } from './BaseInputField/BaseInputField.types';
import { tokens } from '@fluentui/react-components';

const DobInput = (props: IBaseDatePickerProps) => {
    return (
        <BaseDatePicker
            {...props}
            name='dob'
            label='Date of Birth'
            value={props.value}
            style={{ borderColor: tokens.colorNeutralBackground2 }}
        />
    );
};

export default DobInput;
